import { UserContact } from "model/business-types";

export interface LocationsMapFilter {
  user: UserContact;
}
